/**
 * <strong>Purpose:</strong> <br>
 * Provides a "watch"-like behavior for the setter of "arrowMode".<br>
 * The text setter must also be triggered when the arrow mode is changed.<br>
 *
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/ArrowModeMixin}<br>
 * {@link module:mw-form/mixins/property/TextMixin}<br>
 * {@link module:mw-form/mixins/property/DropDownButtonTextMixin}<br>
 *
 * @module mw-form/mixins/property/DropDownButtonArrowModeMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "mw-form/mixins/property/ArrowModeMixin",
        "mw-form/mixins/property/TextMixin",
        "mw-form/mixins/property/DropDownButtonTextMixin"
    ],
    function (declare, ArrowModeMixin, TextMixin, DropDownButtonTextMixin) {
        var DropDownButtonArrowModeMixin = declare(null, {

            _setArrowModeAttr: function () {
                this.inherited(arguments);
                this.set("text", this.get("text"));
            }

        });

        DropDownButtonArrowModeMixin._dependencies = [
            {mixin: ArrowModeMixin, orderDependent: true},
            {mixin: TextMixin, orderDependent: false},
            {mixin: DropDownButtonTextMixin, orderDependent: false}
        ];

        return DropDownButtonArrowModeMixin;
    });